import React, { useState } from 'react';
import { useForm } from '../context/FormContext';
import { isValidName } from '../utils/validation';

export default function Step02_Personal({ onNext, onBack }) {
  const { state, dispatch } = useForm();
  const [errs, setErrs] = useState({});
  const p = state.personal;

  const set = (field, val) => {
    dispatch({ type: 'SET_NESTED', key: 'personal', value: { [field]: val } });
    setErrs(e => ({ ...e, [field]: '' }));
  };

  const next = () => {
    const e = {};
    if (!p.firstName.trim()) e.firstName = 'First name required';
    else if (!isValidName(p.firstName)) e.firstName = 'Letters, hyphens, and apostrophes only';
    if (!p.lastName.trim()) e.lastName = 'Last name required';
    else if (!isValidName(p.lastName)) e.lastName = 'Letters, hyphens, and apostrophes only';
    if (p.middleName && !isValidName(p.middleName)) e.middleName = 'Letters, hyphens, and apostrophes only';
    if (Object.keys(e).length) { setErrs(e); return; }
    onNext();
  };

  return (
    <div className="step-card">
      <h2 className="step-title">Personal Information</h2>
      <p className="step-subtitle">Please enter your legal name exactly as it appears on your ID.</p>
      <div className="field-row">
        <div className="field-group">
          <label className="field-label">First Name <span className="required">*</span></label>
          <input className={`field-input ${errs.firstName ? 'error' : ''}`} value={p.firstName}
            onChange={e => set('firstName', e.target.value)} placeholder="First" />
          {errs.firstName && <div className="field-error">{errs.firstName}</div>}
        </div>
        <div className="field-group">
          <label className="field-label">Middle Name</label>
          <input className={`field-input ${errs.middleName ? 'error' : ''}`} value={p.middleName}
            onChange={e => set('middleName', e.target.value)} placeholder="Middle (optional)" />
          {errs.middleName && <div className="field-error">{errs.middleName}</div>}
        </div>
      </div>
      <div className="field-row">
        <div className="field-group">
          <label className="field-label">Last Name <span className="required">*</span></label>
          <input className={`field-input ${errs.lastName ? 'error' : ''}`} value={p.lastName}
            onChange={e => set('lastName', e.target.value)} placeholder="Last" />
          {errs.lastName && <div className="field-error">{errs.lastName}</div>}
        </div>
        <div className="field-group">
          <label className="field-label">Suffix</label>
          <select className="field-select" value={p.suffix} onChange={e => set('suffix', e.target.value)}>
            <option value="">None</option>
            <option>Jr.</option><option>Sr.</option>
            <option>II</option><option>III</option><option>IV</option>
          </select>
        </div>
      </div>
      <div className="wizard-nav" style={{ position: 'static', borderTop: 'none', padding: 0, marginTop: 24 }}>
        <button className="btn-back" onClick={onBack}>← Back</button>
        <button className="btn-next" onClick={next}>Next →</button>
      </div>
    </div>
  );
}
